import restoreConversations from './restoreConversations';
import restoreItems from './restoreItems';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { ActionSource } from 'owa-mail-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export default function restoreMailListRows(
    rowKeys: string[],
    originalTableViewId: string,
    actionSource?: ActionSource
) {
    const tableView = listViewStore.tableViews.get(originalTableViewId);
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            restoreConversations(rowKeys, originalTableViewId);
            break;

        case ReactListViewType.Message:
            restoreItems(rowKeys, originalTableViewId);
            break;
    }
}
